module.exports = __webpack_public_path__ + "1e09c842088a1151e7aef1251025e6b6.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/211.png
// module id = 1777
// module chunks = 2